exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-info[data-v-3020ad48]{background:#fafafa;border:1px solid #f5f5f5;padding:20px;position:relative;margin-top:40px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hd[data-v-3020ad48]{font-size:16px}.hd span[data-v-3020ad48]{color:#999;margin-right:4px}.ico-arr[data-v-3020ad48]{position:absolute;right:10px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);color:#ccc}.tool-btn[data-v-3020ad48]{margin-top:5px}.tool-btn a[data-v-3020ad48]{font-size:12px;color:#999;color:#0095ff}", ""]);

// exports
